import { DataState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const increaseRequestVersionReducer = (state: DataState) => {
  state.requestVersion += 1;
};

export default increaseRequestVersionReducer;
